/** Current-balance data-access layer — maps the shared `myMemberInfo` query to a payments balance. */

import type { MyMemberInfo } from '@/hooks/member/memberInfoApi';

export interface CurrentBalance {
  /**
   * Outstanding (positive), credit (negative), or paid-up (zero) balance. `null` means the value
   * is genuinely unknown — kept distinct from `0` so a data gap can't render as "you're all paid
   * up".
   */
  amount: number | null;
  /** Due date of the oldest unpaid invoice, or `null` if there isn't one on file. */
  dueDate: string | null;
  /** Backend-computed days past due, passed through as-is — never re-derived client-side. */
  daysPastDue: number | null;
}

export function mapToCurrentBalance(member: MyMemberInfo): CurrentBalance {
  return {
    amount: member?.currentBalanceFormula ?? null,
    dueDate: member?.dateOfOldestUnpaidInvoice ?? null,
    daysPastDue: member?.billingDaysPastDue ?? null,
  };
}
